import { render } from "./CategoryMenuItem.vue?vue&type=template&id=da417570&scoped=true"
import script from "./CategoryMenuItem.vue?vue&type=script&lang=js"
export * from "./CategoryMenuItem.vue?vue&type=script&lang=js"

import "./CategoryMenuItem.vue?vue&type=style&index=0&id=da417570&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-da417570"]])

export default __exports__